import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IWebRequestOptions } from 'src/app/shared/interfaces/web-request.interface';

export interface ICipherCommunicator {
  encryptRequest(options: IWebRequestOptions): Promise<IWebRequestOptions>;

  decryptResponse(encryptedResponse: HttpResponse<any>, options: IWebRequestOptions): Promise<HttpResponse<any>>;
}

@Injectable({
  providedIn: 'root',
})
export class CipherCommunicatorService implements ICipherCommunicator {
  constructor() { /**/ }

  encryptRequest(options: IWebRequestOptions): Promise<IWebRequestOptions> {
    return new Promise<IWebRequestOptions>((resolve, reject) => {
      resolve(options);
      reject();
      return;
    });
  }

  decryptResponse(encryptedResponse: HttpResponse<any>, _options: IWebRequestOptions): Promise<HttpResponse<any>> {
    return new Promise<HttpResponse<any>>(resolve => {
      resolve(encryptedResponse);
      return;
    });
  }
}
